import type { GlobalSearchJobLevel, GlobalSearchJobRole } from '../../data-contract/global-search';

type JobRoleSearchResultUrlData = Pick<GlobalSearchJobRole, 'clusterId' | 'familyId' | 'id' | 'jobArchitectureId'>;
type JobLevelSearchResultUrlData = Pick<
    GlobalSearchJobLevel,
    'clusterId' | 'familyId' | 'id' | 'jobArchitectureId' | 'roleId'
>;

const setSearchParamIfDefined = (params: URLSearchParams, key: string, value: string | null | undefined): void => {
    if (typeof value === 'string' && value.length > 0) {
        params.set(key, value);
    }
};

export const buildJobRoleSearchResultUrl = (role: JobRoleSearchResultUrlData): string => {
    const params = new URLSearchParams();

    setSearchParamIfDefined(params, 'family', role.familyId);
    setSearchParamIfDefined(params, 'cluster', role.clusterId);
    params.set('role', role.id);
    params.set('details', 'job-profile');
    params.set('details.profileId', role.id);
    setSearchParamIfDefined(params, 'details.clusterId', role.clusterId);
    params.set('details.type', 'job-role');
    params.set('details.mode', 'view');

    return `/job-architecture-v2/${role.jobArchitectureId}/overview?${params.toString()}`;
};

export const buildJobLevelSearchResultUrl = (level: JobLevelSearchResultUrlData): string => {
    const params = new URLSearchParams();

    setSearchParamIfDefined(params, 'family', level.familyId);
    setSearchParamIfDefined(params, 'cluster', level.clusterId);
    params.set('role', level.roleId);
    params.set('level', level.id);
    params.set('details', 'job-profile');
    params.set('details.profileId', level.id);
    setSearchParamIfDefined(params, 'details.clusterId', level.clusterId);
    params.set('details.type', 'job-level');
    params.set('details.mode', 'view');

    return `/job-architecture-v2/${level.jobArchitectureId}/overview?${params.toString()}`;
};
